// Appels HTTP vers /api/plans (Lot 8.2).
//
// Route PUBLIQUE : pas d'Authorization header, contrairement à `api.get`
// qui injecte systématiquement le token. On utilise `fetch` directement
// pour que la page /pricing soit accessible sans compte et cacheable
// côté browser/CDN.

import type { PlanPublic } from "./types";

export async function fetchPublicPlans(
  signal?: AbortSignal,
): Promise<PlanPublic[]> {
  const res = await fetch("/api/plans", { signal });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${res.statusText}`);
  }
  return (await res.json()) as PlanPublic[];
}
